import { cn } from '@/app/lib/utils/tailwindcss';

interface TabFilterItemProps {
  label: string;
  isSelected: boolean;
  disabled?: boolean;
  underline?: boolean;
  onClick: () => void;
  className?: string;
}

export default function TabFilterItem({ label, isSelected, disabled, underline, onClick, className }: TabFilterItemProps) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={isSelected}
      aria-disabled={disabled}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50',
        'h-[32px] shrink-0 bg-transparent px-0.5 transition-colors',
        disabled && 'typo-body-5 text-filter-tab-disabled-text cursor-not-allowed',
        disabled && underline && 'border-b border-filter-tab-disabled-border',
        !disabled && isSelected && 'typo-body-4 text-filter-tab-focused-text cursor-default',
        !disabled && isSelected && underline && 'border-b border-filter-tab-focused-border',
        !disabled && !isSelected && 'typo-body-5 text-filter-tab-default-text cursor-pointer',
        !disabled && !isSelected && underline && 'border-b border-filter-tab-default-border',
        className,
      )}
    >
      {label}
    </button>
  );
}
